import { h } from 'preact';
import { Text as PreactText } from 'preact-i18n';
import { KeysOfLocalizations } from './localizations';

/**
 * TextProps can't be extended from preact-i18n because there is no exported type to use.
 *
 * This type was found in @types/preact-i18n then copied here. `id` field is the only changed key.
 */
interface TextProps {
  children?: string | undefined;
  id: KeysOfLocalizations;
  fields?: Record<string, string> | undefined;
  plural?: number | undefined;
}

export const FinText: (props: TextProps) => h.JSX.Element = PreactText;
